import { Button, Input, Link } from '@heroui/react';
import { useMask } from '@react-input/mask';
import { SubmitHandler, useForm } from 'react-hook-form';
import { maskConfig } from '@shared/const/mask.ts';
import { useLogin } from '../../entites/authorization';
import { usePhoneResolver } from '../../entites/authorization';

type Form = {
  phone: string;
};

export const DesktopPhoneForm = ({
  onSuccess,
  onClose,
}: {
  onSuccess: (phone: string) => void;
  onClose: () => void;
}) => {
  const { trigger, isMutating } = useLogin();
  const resolver = usePhoneResolver();
  const inputRef = useMask(maskConfig);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<Form>({ resolver });

  const onSubmit: SubmitHandler<Form> = async ({ phone }) => {
    trigger({ phone })
      .then(() => onSuccess(phone))
      .catch(() => {});
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col items-center mt-9"
    >
      <Input
        {...register('phone')}
        ref={inputRef}
        type="tel"
        autoFocus
        placeholder="Номер телефона"
        classNames={{
          innerWrapper: 'h-14',
        }}
        size="lg"
        labelPlacement="inside"
        onValueChange={(v) => setValue('phone', v)}
        isInvalid={!!errors.phone?.message}
        errorMessage={errors.phone?.message}
      />

      <div className="text-sm text-[#60656C] mt-6 break-words text-wrap">
        Продолжая, вы соглашаетесь c{' '}
        <Link size="sm" href="/public">
          Правилами
        </Link>{' '}
        и
        <Link size="sm" href="/public">
          Политикой конфиденциальности
        </Link>
      </div>

      <div className="w-full mt-8 flex flex-row items-center justify-end gap-x-6">
        <Button
          variant="flat"
          className="w-40"
          type="button"
          size="lg"
          onPress={onClose}
        >
          Отмена
        </Button>

        <Button
          type="submit"
          isLoading={isMutating}
          className="w-40"
          color="primary"
          size="lg"
        >
          Войти
        </Button>
      </div>
    </form>
  );
};
